import Image from 'next/image';
import { useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { useTheme } from 'next-themes';

import { ETheme } from '@/enums/theme';

import { OfferItem } from './OfferItem';
import { MonthOption } from './MonthOption';

import styles from './index.module.scss';

export const DeviceOffers = ({ data }) => {
  const [selectedMonth, setSelectedMonth] = useState(
    Math.max(...data?.instalment_payment?.months),
  );
  const { theme } = useTheme();
  const { t, lang } = useTranslation();

  const installmentIcon = () => {
    return theme === ETheme.DARK_MODE
      ? data?.instalment_payment?.dark_mode_icon
      : data?.instalment_payment?.icon;
  };
  return (
    <div className={styles.right} itemScope itemType='https://schema.org/Offer'>
      <h2>{data?.offer?.title}</h2>
      <div className={styles.offerIncludes}>
        {data?.offer?.inclusions?.map((offer) => {
          return (
            <OfferItem
              key={offer}
              icon={offer?.icon}
              value={offer?.description}
              title={offer?.title}
            />
          );
        })}
      </div>
      <div className={styles.birbankMonths}>
        <div className={styles.title}>
          {data?.instalment_payment?.icon &&
            data?.instalment_payment?.dark_mode_icon && (
              <Image
                alt={data?.instalment_payment?.title}
                title={data?.instalment_payment?.title}
                width={24}
                height={24}
                src={installmentIcon()}
                className={styles.icon}
              />
            )}
          <p>{data?.instalment_payment?.title}</p>
        </div>
        <div className={styles.monthlyOptions}>
          {data?.instalment_payment?.months?.map((monthOption) => {
            return (
              <MonthOption
                key={monthOption}
                option={monthOption}
                selectedMonth={selectedMonth}
                setSelectedMonth={setSelectedMonth}
                unit={data?.instalment_payment?.unit}
              />
            );
          })}
        </div>
        {selectedMonth && (
          <div className={styles.calculator}>
            {lang !== 'en' && <span>{t('common:perMonth')}</span>}
            <span className={styles.calculator__bold}>
              {data?.new_price
                ? (data?.new_price / Number(selectedMonth)).toFixed(2)
                : (data?.old_price / Number(selectedMonth)).toFixed(2)}
              {data?.currency}
            </span>
            {lang === 'en' && <span>{t('common:perMonth')}</span>}
          </div>
        )}
      </div>
    </div>
  );
};
